import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=e81e77e8&scoped=true"
import script from "./sign-up.vue?vue&type=script&lang=js"
export * from "./sign-up.vue?vue&type=script&lang=js"
import style0 from "./sign-up.vue?vue&type=style&index=0&id=e81e77e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81e77e8",
  null
  
)

export default component.exports